<template>
	<div v-if="loaded" class="row">
		<div class="col-12 mb-4 d-flex flex-row align-items-center">
			<h1 class="mr-auto">
				{{ teacher.displayName }}
				<button class="btn btn-outline-dark btn-sm" @click="selectTeacher()">{{ $t('change') }}</button>
			</h1>
		</div>
		<template >

		</template>
		<div
			v-if="hasPrivs && teacher"
			class="col-12 mb-4"
		>
			<IndividualTimetable
				:userId="teacherId"
				:from="from"
				:until="until"
				:events="events"
				@selectEvent="selectEvent"
			/>
		</div>
		<div v-else class="col-12 mb-4 clearfix">
			<div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n" />
		</div>

		<EventDetailsModal
			v-if="selectedEvent"
			v-model="modalVisible"
			:event="selectedEvent"
		/>
	</div>
</template>

<script>
import IndividualTimetable from 'src/components/Timetables/IndividualTimetable.vue';
import EventDetailsModal from 'src/components/Timetables/EventDetailsModal.vue';

export default {
	components: {
		IndividualTimetable,
		EventDetailsModal
	},
	data() {
		return {
			loaded: false,
			teacherId: 0,
			teacher: null,
			events: [],
			from: null,
			until: null,
			teacherResolve: null,
			sessionTypes: [],
			modalVisible: false,
			selectedEvent: null,

		}
	},
	mounted() {
		this.setTeacherAndTimetable()
	},
	methods: {
		setTeacherAndTimetable() {
			const teacherSet = new Promise(resolve => this.teacherResolve = resolve)
			const isAdmin = this.$UserSession.hasPriv.call(this, 'TIMETABLE_VIEW_ALL') || this.$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')
			const isTeacher = !isAdmin && this.$UserSession.hasPriv.call(this, 'TIMETABLE_VIEW')

			if (isTeacher) {
				this.teacherId = Number(this.$UserSession.getValue("id"))
				this.getTeacherDetails()
			}
			else if (isAdmin) {
				if (this.$route.params.teacherid) {
					this.teacherId = Number(this.$route.params["teacherid"])
					this.getTeacherDetails()
				}
				else {
					this.selectTeacher()
				}
			}
			else {
				return
			}

			teacherSet.then(() => {
				Promise.all([this.fetchEvents(), this.fetchSessionTypes()]).then(() => {
					this.processEvents()
					this.loaded = true
				})
			})
		},
		selectTeacher() {
			if (!this.$UserSession.hasPriv.call(this, 'TIMETABLE_VIEW_ALL')) return;

			const self = this;
			this.$users.getTeachers.call(this).then(teachers => {
				const processedTeachers = teachers.map(teacher => {
				if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)");
				}
				return teacher;
				});
				this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-a-teacher"),
				selectCallback: function(selection) {
					self.$store.commit("closeModal");
					self.$router.replace(`/timetables/individualteacher/${selection.id}`);
				},
				selected: [],
				data: processedTeachers,
				captionKey: "displayName",
				subcaptionKey: "subcaption",
				teacherSearchFilters: true
				});
			});
		},

		getTeacherDetails() {
			return this.$users.getUserById.call(this, this.teacherId).then(teacher => {
				this.teacher = teacher
				if (this.teacherResolve) this.teacherResolve()
			})
		},
		fetchEvents() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/teachers/events/all`, {
				method: 'GET',
				data: { user_id: this.teacherId },
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error()

				this.events = res.results.map(event => {
					event.students = event.teachers
					delete event.teachers
					return event
				})
				this.from = res.from
				this.until = res.to
			}).catch(err => {
				console.error(err)
				this.$log.error.call(this, err)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-fetching-events'),
					confirmCallBack() {
						this.$router.push('/timetables')
					}
				})
			})
		},
		fetchSessionTypes() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/sessiontypes/all`, {
                method: 'GET',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.sessionTypes = res.results
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-session-types'),
                })
            })
        },
		processEvents() {
			const sessionTypesById = {}
			const roomsById = {}

			this.sessionTypes.forEach(type => {
				sessionTypesById[type.id] = type
				type.ttrooms.forEach(room => {
					roomsById[room.id] = room
				})
			})
			this.events = this.events.map(event => {
				event.ttsessiontype = sessionTypesById[event.ttsessiontype_id]
				event.ttroom = roomsById[event.ttroom_id]
				return event
			})
		},
		selectEvent(event) {
			this.selectedEvent = event;
			this.modalVisible = true;
			// Fetch additional details for timetable events, but NOT background events
			if(event.ttsessiontype_id){
				return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/events/get`, {
					method: 'GET',
					data: {
						id: this.selectedEvent.id,
					}
				}).then(res => {
					if (res.status == 'SUCCESS'){
						this.selectedEvent = {
							...this.selectedEvent,
							...res.result
						}
					}
				}).catch(err => {
					this.$log.error.call(this, err)
				})
			} else {
				return true;
			}
		},
	},
	computed: {
		hasPrivs() {
			return this.$UserSession.hasPriv('TIMETABLE_VIEW_ALL')
			|| this.$UserSession.hasPriv('TIMETABLE_VIEW')
			|| this.$UserSession.hasPriv('TIMETABLE_ADMIN')
		}
	}
}
</script>
